import { useRouter } from 'next/router';
import { useQuery } from '@apollo/client';
// Api
import { GET_STORE_BY_SLUG } from 'api/store/queries';
// Types
import {
  GetStoreBySlug,
  GetStoreBySlugVariables,
} from 'api/store/types/GetStoreBySlug';
// Helpers
import { cleanSlug } from 'helpers/routes';
import { getStoreMetaData } from 'helpers/meta';
// Hooks
import { useIsOwnProfile } from './useIsOwnProfile';

const RESERVED_FILE_NAMES_REGEXP = /\.css\.map|favicon\.ico|apple-app-site-association|apple-touch-icon-precomposed\.png|apple-touch-icon\.png|apple-touch-icon-120x120-precomposed\.png|\.json/;

export const useAthletePageData = () => {
  const router = useRouter();
  const { athleteSlug } = router.query;
  const skip = RESERVED_FILE_NAMES_REGEXP.test(`${athleteSlug}`);

  // clean tracking URL params
  const cleanedSlug = cleanSlug(athleteSlug);

  // Check if current user is viewing their own profile
  const isOwnProfile = useIsOwnProfile(cleanedSlug);

  const { data, error, loading } = useQuery<
    GetStoreBySlug,
    GetStoreBySlugVariables
  >(GET_STORE_BY_SLUG, {
    fetchPolicy: 'cache-first',
    variables: {
      input: {
        slug: cleanedSlug as string,
      },
      withFollowerCount: isOwnProfile,
    },
    skip,
  });

  const metaData = getStoreMetaData(data?.store);

  return {
    data,
    error,
    loading,
    skip,
    cleanedSlug,
    athleteSlug,
    metaData,
    store: data?.store,
  };
};
